import {
  FETCH_ORDER_ACCEPT_PENDING,
  FETCH_ORDER_ACCEPT_REJECTED,
  FETCH_ORDER_ACCEPT_FULFILLED
} from "../constants/orderAccept";

import { RESET_ORDER } from "../constants/orderSearch";

const initialState = {
  pending: false,
  error: {},
  success: false
};

export const orderAccept = (state = initialState, action) => {
  switch (action.type) {
    case RESET_ORDER:
      return { sucess: false, pending: false, error: {} };

    case FETCH_ORDER_ACCEPT_PENDING:
      return { ...state, pending: true, error: [] };

    case FETCH_ORDER_ACCEPT_REJECTED:
      return { ...state, pending: false, error: action.error.response.data };

    case FETCH_ORDER_ACCEPT_FULFILLED:
      return {
        ...state,
        pending: false,
        success: true,
        error: []
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderAccept.js